import { addMonths, endOfMonth, format, isValid, parse, startOfMonth } from 'date-fns'

/**
 * The `YYYY-MM` month a calendar URL carries (`?month=2026-10`).
 *
 * Kept as the string the URL holds and parsed on demand, so the URL stays the
 * one source of truth and a malformed value falls back instead of throwing.
 */
const MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/

export function isMonthParam(value: string | null | undefined): value is string {
  return typeof value === 'string' && MONTH_PATTERN.test(value)
}

/** The month a calendar opens on when the URL names none or names garbage. */
export function currentMonthParam(now: Date = new Date()): string {
  return format(now, 'yyyy-MM')
}

export function monthParamToDate(month: string): Date {
  const parsed = parse(month, 'yyyy-MM', new Date(2000, 0, 1))
  return isValid(parsed) ? startOfMonth(parsed) : startOfMonth(new Date())
}

export function dateToMonthParam(date: Date): string {
  return format(date, 'yyyy-MM')
}

export function shiftMonthParam(month: string, delta: number): string {
  return dateToMonthParam(addMonths(monthParamToDate(month), delta))
}

/** First and last day of a month as the `YYYY-MM-DD` days the calendar read takes. */
export function monthRange(month: string): { from: string; to: string } {
  const start = monthParamToDate(month)
  return { from: format(start, 'yyyy-MM-dd'), to: format(endOfMonth(start), 'yyyy-MM-dd') }
}
